(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.jf-cart-recommendation__form');
    if (!form) return;

    event.preventDefault();

    const button = form.querySelector('.jf-cart-recommendation__add');
    const spinner = form.querySelector('.loading__spinner');
    const errorWrapper = form.parentElement.querySelector('.product-form__error-message-wrapper');
    const errorText = errorWrapper.querySelector('.product-form__error-message');
    const drawer = document.querySelector('cart-drawer');

    if (!button || button.disabled) return;

    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    spinner.classList.remove('hidden');
    errorWrapper.hidden = true;

    try {
      const formData = new FormData(form);
      const sectionIds = drawer && typeof drawer.getSectionsToRender === 'function'
        ? drawer.getSectionsToRender().map((section) => section.id)
        : ['cart-drawer', 'cart-icon-bubble'];

      formData.append('sections', sectionIds.join(','));
      formData.append('sections_url', window.location.pathname);

      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });
      const cartState = await response.json();

      if (!response.ok || cartState.status) {
        throw new Error(cartState.description || cartState.message || window.cartStrings.error);
      }

      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.setActiveElement(button);
        drawer.renderContents(cartState);
      } else {
        window.location.assign(window.routes.cart_url);
      }
    } catch (error) {
      errorText.textContent = error.message || window.cartStrings.error;
      errorWrapper.hidden = false;
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-disabled');
      spinner.classList.add('hidden');
    }
  });
  } catch(e) { console.error(e); }
})();

})();
